import { render, staticRenderFns } from "./CdbCustomerBasic.vue?vue&type=template&id=6f3f9815&scoped=true&"
import script from "./CdbCustomerBasic.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerBasic.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerBasic.vue?vue&type=style&index=0&id=6f3f9815&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f9815",
  null
  
)

export default component.exports